import React, { useState } from 'react';
import './HOASection.css';

const HOASection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selections, setSelections] = useState({
    commonArea: false,
    excludeCurb: false,
    includeFront: false,
  });

  const toggleSelection = (key) => {
    setSelections(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="hoa-container">
      {/* MAIN SUMMARY CARD */}
      <div className="hoa-card">
        <div className="hoa-header">
          <div className="hoa-title">
            <i className="fas fa-building hoa-icon-purple"></i>
            <span>HOA Specification</span>
          </div>
          <button className="settings-btn" onClick={() => setIsModalOpen(true)}>
            <i className="fas fa-cog"></i>
          </button>
        </div>

        <div className="hoa-options-list">
          <label className="summary-option">
            <input type="checkbox" checked={selections.commonArea} readOnly />
            <span className="checkbox-custom"></span>
            Common Area Only
          </label>
          <label className="summary-option">
            <input type="checkbox" checked={selections.excludeCurb} readOnly />
            <span className="checkbox-custom"></span>
            Exclude Curb Strips
          </label>
          <label className="summary-option">
            <input type="checkbox" checked={selections.includeFront} readOnly />
            <span className="checkbox-custom"></span>
            Include Front Yard
          </label>
        </div>
      </div>

      {/* MODAL SECTION */}
      {isModalOpen && (
        <div className="hoa-modal-overlay">
          <div className="hoa-modal-content">
            <div className="modal-header">
              <div className="modal-title-main">
                <i className="fas fa-building me-2"></i> HOA Specification
              </div>
              <button className="close-x" onClick={() => setIsModalOpen(false)}>&times;</button>
            </div>

            <div className="modal-scroll-body">
              {/* Info Box */}
              <div className="about-hoa-box">
                <p className='text-dark'><strong>About HOA:</strong> Homeowners Association (HOA) specifications define common area maintenance requirements, curb regulations, and yard inclusion policies for residential communities. Selecting HOA options helps calculate accurate service coverage and pricing.</p>
              </div>

              {/* Detailed Options */}
              <div className="modal-option-card" onClick={() => toggleSelection('commonArea')}>
                <div className="option-top">
                  <div className={`checkbox-ui ${selections.commonArea ? 'checked' : ''}`}></div>
                  <div className="option-label">Common Area Only</div>
                  <div className="discount-badge">30% OFF</div>
                </div>
                <p className="option-desc">Service covers only HOA-maintained common areas like parks, clubhouses, and community spaces.</p>
              </div>

              <div className="modal-option-card" onClick={() => toggleSelection('excludeCurb')}>
                <div className="option-top">
                  <div className={`checkbox-ui ${selections.excludeCurb ? 'checked' : ''}`}></div>
                  <div className="option-label">Exclude Curb Strips</div>
                </div>
                <p className="option-desc">Excludes grass strips between sidewalk and road from maintenance services.</p>
              </div>

              <div className="modal-option-card" onClick={() => toggleSelection('includeFront')}>
                <div className="option-top">
                  <div className={`checkbox-ui ${selections.includeFront ? 'checked' : ''}`}></div>
                  <div className="option-label">Include Front Yard</div>
                  <div className="discount-badge">15% OFF</div>
                </div>
                <p className="option-desc">Extends services to include front yards of individual homes within the community.</p>
              </div>

              {/* Automatic Discount Alert */}
              <div className="discount-alert-box">
                <div className="alert-title">
                  <i className="fas fa-tag me-2"></i> Automatic Discount
                </div>
                <p>Selecting <strong>"Common Area Only"</strong> applies <strong>30% automatic discount</strong> to total estimate as service area is reduced to community spaces only.</p>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn-cancel" onClick={() => setIsModalOpen(false)}>Cancel</button>
              <button className="btn-apply" onClick={() => setIsModalOpen(false)}>Apply Selection</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HOASection;